import * as React from "react";

export default ({ color = '#fff', size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="6" fill={color} />
    <path
      d="M3.49023 5.9841L5.15421 7.64808L8.48216 4.32013"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 3.8831C4 3.49445 4.42399 3.25439 4.75725 3.45435L8.28542 5.57125C8.60909 5.76546 8.60909 6.23454 8.28542 6.42875L4.75725 8.54565C4.42399 8.74561 4 8.50555 4 8.1169V3.8831Z"
      fill="#221CB6"
    />
  </svg>
);
